uvex-google-map {
  transition: all 0.5s;
  margin-bottom: 2rem;
  display: block;
  flex: 0 0 100%;
  max-width: 100%;
  height: 650px;
  overflow: hidden;
  position: relative;

  @media (min-width: 992px) {
    height: 600px;
  }

  .map {
    display: block;
    width: 100%;
    height: 100%;

    svg.marker-cluster {
      fill: var(--brand-primary, #ff6600);

      &.hover {
        height: 60px !important;
        transform: translate(0, 30px);
        width: 60px !important;
      }
    }
  }
}
